import { Link as ScrollTo } from 'react-scroll';
import * as enums from '../../enums';
import cx from 'classnames';
import s from './styles.scss';
import { ButtonScrollProps } from './types';

export const ButtonScroll = ({
  children,
  className,
  variant = enums.Variant.DEFAULT,
  color = enums.ColorTheme.PRIMARY,
  size = enums.Size.MEDIUM,
  disabled = false,
  hasError = false,
  scrollTo,
  offset,
}: ButtonScrollProps): JSX.Element => {
  const buttonCx = cx(
    s.button,
    s[size],
    s[variant],
    s[color],
    { [s.disabled]: disabled },
    { [s.error]: hasError },
    className
  );

  return (
    <ScrollTo
      role="button"
      className={buttonCx}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      to={scrollTo}
      offset={offset}
      smooth
    >
      {children}
    </ScrollTo>
  );
};
